export enum signUpFlowStatEnum {
  setUpAccount = 1,
  welcome = 2,
}

export interface IUserProperties {
  name: string;
  familyName: string;
}

export interface ISignUpFlowState {
  state?: signUpFlowStatEnum;
  onLogin?(): void;
  onSignUp?(data: IUserProperties): void;
  username: string;
  password: string;
}

export interface ISignupCardinals {
  username: string;
  password: string;
  phoneNumber?: string;
  extraUserProperties?: Partial<IUserProperties>;
}

export interface ISignupLinkAccount {
  cognitoUsername: string;
  invite: string;
}

export interface ISignupLinkAccountWithToken {
  token: string;
  invite: string;
}

export interface ICognitoSignupCardinals extends ISignupCardinals {
  onComplete(cardinals: ISignupLinkAccount): Promise<void>;
  onFail?(err: string): void;
}

export interface IInviteLink {
  clinic: string;
  expiresAt: string;
  forceVerifiedUsers: boolean;
  clinicianAppEnabled: boolean;
}

export interface IOTPResult {
  userUuid: string;
  otp: string;
}
